<template>
    <div
      :class="['modal-container', { active: active }]"
      style="max-width: 100%;"
    >
      <div class="card head-card news">
        <div class="title-card">
          <h4>Elegir grupo</h4>
          <button class="touchpad" @click="cancelar">x</button>
        </div>
        <div class="card-content">
          <div class="row">
            <div class="col-12">
              <div
                class="card-content"
                style="max-height: 400px; overflow-y: auto;"
              >
                <div
                  class="checkbox iconed"
                  v-for="(value, index) in getGrupos"
                  :key="index"
                >
                  <label>
                    <input
                      class="box"
                      type="checkbox"
                      :id="'group-' + index"
                      :value="value.id"
                      v-model="selectedGroups"
                    />
  
                    {{ value.grupo }}
                    <span class="nbox">
                      <svg viewBox="0 0 14.018 13.003">
                        <path
                          id="Rectángulo_9"
                          data-name="Rectángulo 9"
                          d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                          transform="translate(-304.98 -380.994)"
                          fill="#fff"
                        />
                      </svg>
                    </span>
                  </label>
                </div>
              </div>
            </div>
  
            <div class="col-12 mt-1">
              <button class="button fluid" @click="guardarw()">
                Guardar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import axios from "axios";
  
  export default {
    props: ["active", "cancelar", "guardar", "error"],
    data() {
      return {
        selectedGroups: [],
        getGrupos: [],
      };
    },
    computed: {},
    mounted() {
      this.get_grupos();
    },
    beforeMount() {},
    methods: {
      async get_grupos() {
        try {
          const response = await axios.post(
            "https://syh26rw9d6.execute-api.us-west-2.amazonaws.com/prod/listaGrupos"
          ); // Reemplaza con tu endpoint
          this.getGrupos = response.data.data;
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      },
  
      guardarw() {
        if (this.selectedGroups.length > 0) {
          this.guardar(this.selectedGroups);
         
        } else {
          console.error("No se ha seleccionado ningún grupo");
        }
      },
    },
  };
  </script>
  <style scoped>
  .touchpad {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
  }
  .button.fluid {
    width: 100%;
    padding: 12px;
    background: #02b99e;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    text-align: center;
  }
  .checkbox {
    display: flex;
    align-items: center;
  }
  
  .checkbox input {
    margin-right: 0.5em;
  }
  
  .checkbox.selected {
    background-color: #0056b3; /* Verde claro */
    border: 2px solid #0056b3; /* Verde claro */
  }
  </style>
  